export const LIVE_ONLINE_CATALOG_URL = "/live-online-catalog";
export const HOME_STUDY_CATALOG_URL = "/home-study-catalog";
export const MY_SERIES_URL = "/my-series";
